export default __webpack_public_path__ + "static/media/arrow-right-blue.a12196b9.svg";